import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";

export const IncentiveSetting = () => {
    const [reload, setReload] = useState<boolean>(false);
    const [modal, setModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });


    const onHideDialog = () => {
        setModal({ singleData: {}, open: false });
        setReload(prev => prev = !prev);
    };

    const toast = useRef<any>(null);

    return (
        <>
            <Form open={modal.open} singleData={modal.singleData} reload={reload} setReload={setReload} hideDialog={onHideDialog} toast={toast} />
            <Table reload={reload} setModal={setModal} toast={toast} />
            <Toast ref={toast} />
        </>
    );
};